module.exports = __webpack_public_path__ + "img/title_m.42b49f9f.png";